import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { NotificationType } from '../enums/notification-type.enum';
import { NotificationGroupType } from '../enums/notification-group-type.enum';
import { NotificationDTO } from '../../core/models/dto/notification.dto';
import { UnreadNotificationsCountDTO } from '../../core/models/dto/unread-notifications-count.dto';

@Injectable({ providedIn: 'root' })
export class NotificationService {
    constructor(private httpClient: HttpClient) {}

    getNotifications(
        skip: number,
        take: number,
        notificationTypes?: NotificationType[],
        notificationGroup?: NotificationGroupType,
        isUnread?: boolean,
    ): Observable<NotificationDTO[]> {
        let params = new HttpParams();
        params = params.append('skip', skip);
        params = params.append('take', take);

        if (notificationTypes) {
            notificationTypes.forEach((type) => {
                params = params.append('types', type);
            });
        }

        if (notificationGroup) {
            params = params.append('notificationGroup', notificationGroup);
        }

        if (isUnread) {
            params = params.append('isUnread', isUnread);
        }

        return this.httpClient.get<NotificationDTO[]>(environment.apiInboxUrl + 'user/notifications', {
            params,
        });
    }

    getNotificationsByNoteId(noteId: number): Observable<NotificationDTO[]> {
        return this.httpClient.get<NotificationDTO[]>(environment.apiInboxUrl + 'user/notifications?noteId=' + noteId);
    }

    getUnreadCount(): Observable<number> {
        return this.httpClient.get<number>(environment.apiInboxUrl + 'user/notifications/unreadcount');
    }

    getUnreadCountsForGroups(isGroupingByGroupTypeNeeded = false): Observable<UnreadNotificationsCountDTO[]> {
        return this.httpClient.get<UnreadNotificationsCountDTO[]>(
            environment.apiInboxUrl +
                'user/notifications/Unread/Counts?isGroupingNeeded=' +
                isGroupingByGroupTypeNeeded,
        );
    }

    readAll(): Observable<void> {
        return this.httpClient.post<void>(environment.apiInboxUrl + 'user/notifications/isread', null);
    }

    read(notificationId: number, status: boolean): Observable<boolean> {
        return this.httpClient.patch<boolean>(
            environment.apiInboxUrl + 'user/notifications/' + notificationId + '/IsRead',
            status,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );
    }
}
